import React, { useEffect } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import YouTubeShort from "../../components/YouTubeShort";
import { howToVideos } from "./reassistVideos";

const RealEstateAssistHowTo = () => {
  const { hash } = useLocation();

  // Links like /how-to#import-from-mls jump to that video. Runs after the
  // app's scroll-to-top on navigation.
  useEffect(() => {
    if (!hash) return undefined;
    const timer = setTimeout(() => {
      document.getElementById(hash.slice(1))?.scrollIntoView({ behavior: "smooth" });
    }, 100);
    return () => clearTimeout(timer);
  }, [hash]);

  return (
    <Container fluid style={styles.container}>
      <Container>
        <Row className="justify-content-center">
          <Col xs={12} md={10} lg={8} style={styles.intro}>
            <h1 style={styles.title}>Real Estate Agent Assist How-To Videos</h1>
            <p style={styles.subtitle}>
              Short walkthroughs for getting set up, each under a minute or
              two. Start with the first and work down.
            </p>
            <p style={styles.note}>
              The videos show the Android app. The iPhone app works the same
              way, and its automatic backups go to your iCloud Drive.
            </p>
          </Col>
        </Row>
        <Row>
          {howToVideos.map((video, index) => (
            <Col
              xs={12}
              sm={6}
              lg={4}
              key={video.slug}
              id={video.slug}
              style={styles.videoCol}
            >
              <YouTubeShort id={video.id} title={video.title} maxWidth={280} />
              <h2 style={styles.videoTitle}>
                <span style={styles.step}>{index + 1}.</span> {video.title}
              </h2>
              <p style={styles.videoDescription}>{video.description}</p>
            </Col>
          ))}
        </Row>
        <Row className="justify-content-center">
          <Col xs={12} md={10} lg={8} style={styles.footerLinks}>
            <p style={styles.note}>
              Still stuck? The{" "}
              <Link to="/apps/real-estate-assist/support" className="footer-link">
                support page
              </Link>{" "}
              answers common questions and has a form to reach us.
            </p>
            <p style={styles.linkRow}>
              <Link to="/apps/real-estate-assist" className="footer-link">
                About Real Estate Agent Assist
              </Link>
              {" · "}
              <Link to="/apps/real-estate-assist/support" className="footer-link">
                Support
              </Link>
              {" · "}
              <Link to="/apps/real-estate-assist/privacy" className="footer-link">
                Privacy Policy
              </Link>
            </p>
          </Col>
        </Row>
      </Container>
    </Container>
  );
};

export default RealEstateAssistHowTo;

const styles = {
  container: {
    backgroundColor: "#000",
    paddingTop: 100,
    paddingBottom: 100,
  },
  footerLinks: {
    marginTop: 24,
    textAlign: "center",
  },
  intro: {
    marginBottom: 48,
    textAlign: "center",
  },
  linkRow: {
    color: "#ACACAC",
    fontSize: 16,
    marginTop: 16,
  },
  note: {
    color: "#ACACAC",
    fontSize: 16,
  },
  step: {
    color: "#CF3620",
  },
  subtitle: {
    color: "#ACACAC",
    fontSize: 18,
    marginBottom: 12,
  },
  title: {
    color: "#FFF",
    fontWeight: 700,
    marginBottom: 12,
  },
  videoCol: {
    marginBottom: 56,
    scrollMarginTop: 90,
    textAlign: "center",
  },
  videoDescription: {
    color: "#ACACAC",
    fontSize: 16,
    lineHeight: 1.6,
    margin: "0 auto",
    maxWidth: 300,
  },
  videoTitle: {
    color: "#FFF",
    fontSize: 20,
    fontWeight: 700,
    marginBottom: 8,
    marginTop: 20,
  },
};
